const WORD_SEPARATORS_REGEX = /[_\-\s]+/g;

export const formatNetworkLabel = (network?: string | null): string => {
  const normalized = network?.trim() ?? "";
  if (!normalized) {
    return "Unknown";
  }

  return normalized
    .replace(WORD_SEPARATORS_REGEX, " ")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
